export function toDubai(input) {
  const d = new Date(input);
  if (isNaN(d)) return "";
  return new Intl.DateTimeFormat("en-GB", {
    timeZone: "Asia/Dubai",
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  }).format(d);
}

/**
 * Returns the current date (YYYY-MM-DD) and hour (0-23) strictly in Asia/Dubai timezone.
 * Guarantees that clients around the world evaluate Dubai local time.
 */
export function getDubaiDate(date = new Date()) {
  const d = new Date(date);
  const ymd = d.toLocaleDateString("en-CA", { timeZone: "Asia/Dubai" });
  const hour = parseInt(
    new Intl.DateTimeFormat("en-US", {
      timeZone: "Asia/Dubai",
      hour: "numeric",
      hourCycle: "h23",
    }).format(d),
    10
  );
  return { ymd, hour };
}

/**
 * Checks whether the current time in Dubai is past the given cutoff hour (default: 17 = 5:00 PM).
 */
export function isAfterDubaiCutoff(cutoffHour = 17, date = new Date()) {
  const { hour } = getDubaiDate(date);
  return hour >= cutoffHour;
}

/**
 * Returns today's date formatted as YYYY-MM-DD in Asia/Dubai timezone.
 */
export function getDubaiTodayYMD(date = new Date()) {
  return getDubaiDate(date).ymd;
}

